<div class="averbacao-nacionalidade-container">
    <!--        -->

    @if (carregando()) {
        <div class="feedback">Carregando dados...</div>
    } @else if (erroConsulta()) {
        <div class="feedback erro">{{ erroConsulta() }}</div>
    } @else if (!dados()) {
        <div class="feedback">Nenhum dado disponível para este protocolo.</div>
    } @else {
        <div class="secoes">
            @for (secao of secoes; track secao.titulo) {
                <app-card-content [headerColor]="false" [title]="secao.titulo" [icon]="iconeDaSecao(secao.titulo)" [subtitle]="subtituloDaSecao(secao.titulo)">
                    <div class="secao-corpo">
                        <div class="campos-grid" [class.campos-grid--solicitante]="secao.titulo === 'Dados do Solicitante'">
                            @for (campo of secao.campos; track campo.label) {
                                @if (secaoEhDeDados(secao.titulo)) {
                                    <div class="field">
                                        <label class="font-semibold block mb-2" [for]="idDoCampo(secao.titulo, campo.label)">{{ campo.label }}</label>
                                        <input pInputText [id]="idDoCampo(secao.titulo, campo.label)" class="w-full" [value]="valorCampo(campo)" disabled />
                                    </div>
                                } @else {
                                    <article
                                        class="campo"
                                        [class.campo--destaque-identificacao]="campo.label.toLowerCase().trim().startsWith('cpf') || campo.label.toLowerCase().trim().startsWith('crm') || campo.label.toLowerCase().includes('cnpj')"
                                        [class.campo--situacao]="campo.chave === 'situacao' || campo.label.toLowerCase().includes('situacao') || campo.label.toLowerCase().includes('situação')"
                                    >
                                        <span class="campo-label">{{ campo.label }}</span>
                                        <div class="campo-valor-box">
                                            @if (campo.chave === 'situacao' || campo.label.toLowerCase().includes('situacao') || campo.label.toLowerCase().includes('situação')) {
                                                <span [class]="'campo-badge situacao-' + situacaoClassePorTexto(valorCampo(campo))">
                                                    {{ rotuloBadgeSituacao(campo.label, valorCampo(campo)) }}
                                                </span>
                                                @if (protocoloSelecionado()?.inPago === false) {
                                                    <span class="campo-badge campo-badge-pagamento nao-pago">Não pago</span>
                                                }
                                            } @else {
                                                <strong class="campo-valor">{{ valorCampo(campo) }}</strong>
                                            }
                                        </div>
                                    </article>
                                }
                            }
                        </div>
                    </div>
                </app-card-content>
            }

            <app-card-content [headerColor]="false" [title]="'Anexos'" [icon]="iconeDaSecao('Anexos')" [subtitle]="subtituloDaSecao('Anexos')">
                <div class="secao-corpo">
                    <div class="campos-grid">
                        <article class="campo campo--anexo">
                            <span class="campo-label">Anexo RG</span>
                            <div class="campo-valor-box campo-valor-box--anexo">
                                @if (possuiAnexoRg()) {
                                    <button type="button" class="campo-link-botao" (click)="onVisualizarAnexoRg($event)" aria-label="Visualizar anexo RG" title="Visualizar anexo RG">
                                        <i class="pi pi-paperclip"></i>
                                        <span>Visualizar anexo</span>
                                    </button>
                                } @else {
                                    <strong class="campo-valor">-</strong>
                                }
                            </div>
                        </article>

                        <article class="campo campo--anexo">
                            <span class="campo-label">Anexo Título Eleitor</span>
                            <div class="campo-valor-box campo-valor-box--anexo">
                                @if (possuiAnexoTituloEleitor()) {
                                    <button type="button" class="campo-link-botao" (click)="onVisualizarAnexoTitulo($event)" aria-label="Visualizar anexo título eleitor" title="Visualizar anexo título eleitor">
                                        <i class="pi pi-paperclip"></i>
                                        <span>Visualizar anexo</span>
                                    </button>
                                } @else {
                                    <strong class="campo-valor">-</strong>
                                }
                            </div>
                        </article>
                    </div>
                </div>
            </app-card-content>
        </div>
    }
</div>

<p-dialog
    appDialogoPadrao="pi pi-paperclip"
    descricao="Documento anexado ao registro."
    [visible]="exibirDialogAnexo()"
    (visibleChange)="exibirDialogAnexo.set($event)"
    [style]="{ width: '90vw', maxWidth: '1200px' }"
    header="Visualização de anexo"
    (onHide)="fecharDialogAnexo()"
>
    @if (blobAnexo(); as blobAnexo) {
        <app-visualizador-pdf [src]="blobAnexo" [fileName]="nomeArquivoAnexo()" [showAll]="false"></app-visualizador-pdf>
    } @else {
        <div class="anexo-feedback">Nenhum anexo disponível para visualização.</div>
    }
</p-dialog>
